module.exports = __webpack_public_path__ + "static/media/CHASIUVER_MENU-normal.bd534c19.png";